import React, {useEffect, useState} from "react";
import styles, {C} from "../styles";
import {apiGetAiSummary, apiGenerateAiSummary} from "../api/aiSummary";

function formatDate(iso) {
    return new Date(iso).toLocaleString("fr-FR", {day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"});
}

export default function AiSummaryPanel({groupId, groupName}) {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        setLoading(true);
        setError("");
        apiGetAiSummary(groupId)
            .then(data => {
                if (data && data.error) {
                    setError(data.error);
                    setSummary(null);
                } else {
                    setSummary(data);
                }
            })
            .catch(() => setError("Impossible de contacter le serveur. Réessayez plus tard."))
            .finally(() => setLoading(false));
    }, [groupId]);

    async function handleGenerate() {
        setGenerating(true);
        setError("");
        try {
            const data = await apiGenerateAiSummary(groupId);
            if (data.error) {
                setError(data.error);
            } else {
                setSummary(data);
            }
        } catch {
            setError("Impossible de contacter le serveur. Réessayez plus tard.");
        } finally {
            setGenerating(false);
        }
    }

    return (
        <div style={{
            backgroundColor: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: 12,
            padding: 18,
            marginBottom: 20,
        }}>
            <h3 style={{margin: "0 0 12px", fontSize: 15, fontFamily: "'Fraunces', serif"}}>🧠 Résumé IA de la semaine — {groupName}</h3>

            {loading ? (
                <p style={{color: C.textMuted, fontSize: 13}}>Chargement...</p>
            ) : summary ? (
                <>
                    <p style={{fontSize: 13, color: C.textMuted, marginBottom: 4}}>Généré le {formatDate(summary.generated_at)}</p>
                    <p style={{whiteSpace: "pre-wrap", fontSize: 14, marginBottom: 12}}>{summary.content}</p>
                </>
            ) : (
                <p style={{color: C.textMuted, fontStyle: "italic", fontSize: 13, marginBottom: 12}}>Aucun résumé généré pour ce collectif.</p>
            )}

            <button onClick={handleGenerate} disabled={generating} style={styles.button}>
                {generating ? "Génération en cours..." : summary ? "Actualiser" : "Générer un résumé"}
            </button>
            {error && <p style={{color: C.danger, fontSize: 13, marginTop: 8}}>{error}</p>}
        </div>
    );
}
